import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import CustomersList from './pages/CustomerList';
import PartnersList from './pages/PartnerList';
import Bookings from './pages/Bookings';
import Dashboard from './pages/Dashboard';
import VerifyPartner from './pages/VerifyPartners';
import ManagerList from './pages/Managers';
import PartnerMap from './pages/PartnerMap';
import LoginScreen from './pages/LoginScreen';
import PaymentHistory from './pages/PaymentHistory';
import Requests from './pages/Requests';
import CancledRequest from './pages/CancledRequest';
import { getToken, messaging, onMessage } from './firebase';
import { patchRequest, server } from './config';
import WIthdrawalRequest from './pages/WIthdrawalRequest';
import { ToastContainer } from 'react-toastify';
import ManageCities from './pages/ManageCities';
import CityAnalytics from './pages/CityAnalytics';
import CityTrafficSignal from './pages/CityTrafficSignal';
import ManageTestingUsers from './pages/TestingNumbers';
import DeletedUsers from './pages/DeletedUsers';
import ManageCategories from './pages/CategoryList';
import ManageSubCategories from './pages/SubCategoryList';
import SendNotification from './pages/SendNotification';
import PromotionalAds from './pages/PromotionalAds';
import CategoryGroups from './pages/CategoryGroups';

const App = () => {
  const isValid=localStorage.getItem('authToken')?true:false
  const [token, setToken] = useState("");
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("../public/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);
      })
      .catch((err) => console.error("Service Worker registration failed:", err));
  }

  useEffect(() => {
    console.log('request for permission');
   
    
    // Request permission for notifications
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log('granted');
        
        getToken(messaging, { vapidKey: "BKRHPXo3U-D5gT4sEh4rxM9V-HOb8I-A6_oBY2EM-u2VXBdcrorw2DSPb4a4mwXoGix9jbhRDTuwa8QQsWhSBrc" })
          .then((currentToken) => {
            if (currentToken) {
              console.log("FCM Token:", currentToken);
              setToken(currentToken); // Save this token in backend for sending notifications
            } else {
              alert('not token')
              console.log("No FCM token available.");
            }
          })
          .catch((err) => console.log("Error fetching token:", err));
      }
    });
    onMessage(messaging, (payload) => {
      console.log("New notification:", payload);
      // alert(`Notification: ${payload.notification.title}`);
    });
    // (async()=>{
    //   if(token){
    //     const uri=server.uri+'users'
    //     // const body=await patchRequest(uri,{fcmToken:token})
    //     if(body==204){
    //       alert('notification')
    //     }
    //   }
     
    // })()
  }, []);
  return (
    <Router>
      {isValid?
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <ToastContainer />
        <div style={{ marginLeft:'50px', width: '100%' }}>
          <Navbar />
          <div style={{ marginTop: 64, padding: 16 }}>
<Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/verification" element={<VerifyPartner />} />
              <Route path="/cities" element={<ManageCities />} />
              <Route path="/city-analytics" element={<CityAnalytics />} />
              <Route path="/city-traffic" element={<CityTrafficSignal />} />
              <Route path="/customers" element={<CustomersList />} />
              <Route path="/partners" element={<PartnersList />} />
              <Route path="/testing" element={<ManageTestingUsers />} />
              <Route path="/cancled" element={<CancledRequest />} />
              <Route path="/categories" element={<ManageCategories />} />
              <Route path="/sub-categories" element={<ManageSubCategories />} />
              <Route path="/category-groups" element={<CategoryGroups />} />
              <Route path="/managers" element={<ManagerList />} />
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/requests" element={<Requests />} />
              <Route path="/partner-map" element={<PartnerMap />} />
              <Route path="/payments" element={<PaymentHistory />} />
              <Route path="/withdrawals" element={<WIthdrawalRequest />} />
              <Route path="/deleted-users" element={<DeletedUsers/>} />
  <Route path="/send-notifications" element={<SendNotification/>} />
              <Route path="/promotional-ads" element={<PromotionalAds/>} />
            </Routes>
            
          </div>
        </div>
      </div>:<LoginScreen/>}
    </Router>
  );
};

export default App;
